export const OFFICE_NOT_LISTED = "__OFFICE_NOT_LISTED__";
export const MANAGING_BROKER_NOT_LISTED = "__MANAGING_BROKER_NOT_LISTED__";

export const OFFICE_NOT_LISTED_LABEL = "My office is not shown";
export const MANAGING_BROKER_NOT_LISTED_LABEL = "My Managing Broker is not shown";

export const isOfficeNotListed = (value) => value === OFFICE_NOT_LISTED;

export const isManagingBrokerNotListed = (value) =>
  value === MANAGING_BROKER_NOT_LISTED;

export const isBrokerageDetailsIncomplete = (agentData = {}) =>
  !agentData.brokerageOfficeID || !agentData.managingBrokerID;

export const formatAddressLine = (office) =>
  [
    office.addressLine1,
    office.addressLine2,
    office.addressCityName,
    [office.addressStateCode, office.addressZip].filter(Boolean).join(" "),
  ]
    .filter((value) => value && value !== "-")
    .join(", ");

export const getOfficeOptionName = (office) =>
  office.officeName || office.addressCityName || "Office";

export const getOfficeAddressDisplayParts = (office) => {
  if (!office) return [];

  const street = [office.addressLine1, office.addressLine2]
    .filter((value) => value && value !== "-")
    .join(", ");
  const cityLine = [
    office.addressCityName,
    office.addressStateCode,
    office.addressZip,
  ]
    .filter((value) => value && value !== "-")
    .join(", ");

  return [street, cityLine].filter(Boolean);
};

// agent/getBrokerageAddressDetails returns the license on `designatedBroker`.
// Profile form state and saves use `brokerLicenseNumber`, so map that field here.
export const getOfficeBrokerLicenseNumber = (office = {}) =>
  office.brokerLicenseNumber || office.designatedBroker || "";

export const mapOfficeToBrokerageFields = (office) => ({
  brokerLicenseNumber: getOfficeBrokerLicenseNumber(office),
  brokerageAddressLine1: office.addressLine1 || "",
  brokerageAddressLine2: office.addressLine2 || "",
  brokerageCityID: String(office.addressCityID || ""),
  brokerageCityName: office.addressCityName || "",
  brokerageCityCode: "-",
  brokerageOfficeID: String(office.officeID || ""),
  brokerageStateCode: office.addressStateCode || "",
  brokerageAddressZip: office.addressZip || "",
});
